export const howItWorks = {
  questions: [
    {
      header: "Create a profile",
      answer:
        "Create your personal profile where you present yourself and your home in a clear way to potential exchange partners.\n\n Share relevant information and interests to help others to get a good perception of who you are and what you offer.\n\n Your profile is the key to finding the right match for your next home change.",
    },
    {
      header: "Publish your home",
      answer:
        "By publishing pictures and descriptions of your home, you give potential exchange partners a clear picture of what to expect. Showcase your home and describe its charms and amenities to create interest and a positive first impression.",
    },
    {
      header: "Search after an exchange",
      answer:
        "Use the search function to find the perfect home exchange for your next trip. Enter your desired destination, dates and preferences to explore a wide range of possible exchange opportunities.",
    },
    {
      header: "Connect with other members",
      answer:
        "Contact other members to investigate a possible mutual home exchange interest. If agreed, \
        phone number and email address will be shared and it is time to discuss dates and tasks with your exchange partner to anchor the exchange.",
    },
    {
      header: "Get ready for your exchange",
      answer:
        "Prepare for your upcoming change by making sure all the details are in place. Take the time to double-check that all the details and all the necessary information are anchored with both parties before the trip.",
    },
  ],
};
